import { Avatar, Clickable, Col, Row, Text } from 'components';
import { closeNotifs, theme } from 'lib';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const UserFollow = ({ data }) => {
  const { sender, timestamp, entityId, type } = data,
    navigate = useNavigate(),
    { t } = useTranslation(),
    dispatch = useDispatch(),
    posts = useSelector((state) => state.user.posts),
    post = posts.find((x) => x._id === entityId);

  if (!sender) return null;

  return (
    <Clickable
      onClick={() => {
        navigate(`/profile/${sender.username}`);
        closeNotifs(dispatch);
      }}
    >
      <Row noFlex pad="0 0 16px" center>
        <Avatar small avatar={sender.avatar} user={sender} />

        <Col marg="0 0 0 16px">
          <Row between start>
            <Trans
              parent={Text}
              components={{
                strong: <Text bold spanned />
              }}
            >
              {t(
                type === 'userFollow'
                  ? 'notifications.startedFollowing'
                  : 'notifications.startedSubscribing',
                { sender: sender.name || sender.username }
              )}
            </Trans>

            <Text b2 med col={theme.GREY_60}>
              {timestamp}
            </Text>
          </Row>
        </Col>
      </Row>
    </Clickable>
  );
};

export default UserFollow;
